import { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import { PoweredBy } from "components/PoweredBy/PoweredBy";
import Footer from "components/Unit/Footer";
import { MapModalButton } from "components/Unit/FullscreenMap";
import Mapbox from "components/Unit/Mapbox";
import { useAtom } from "jotai";
import { map_State } from "state/store.global";
import SignUpForm from "./SignUpForm";

export const MobileFooter = () => {
  const [open] = useAtom(map_State);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return (
    <>
      {/* 🗺️ Mapbox sits OUTSIDE the gradient section */}
      <Box sx={{ position: "relative", zIndex: 2 }}>
        {hydrated && !open && <Mapbox />}
        <MapModalButton />
      </Box>

      {/* 🌈 Gradient Section starts below the map */}
      <Box
        sx={{
          // background: `linear-gradient(180deg, ${f_clr.primaryColor} 0%, ${f_clr.primaryColor}66 100%)`,
          background: "#F0EEEF",
          color: "#000",
          position: "relative",
          zIndex: 1,
          mt: "-4px", // slight overlap to avoid visible gap
        }}
      >
        <Grid
          item
          sx={(theme) => ({
            [theme.breakpoints.down("1024")]: {
              maxWidth: "698px",
              mx: "auto",
            },
          })}
        >
          <SignUpForm />
        </Grid>

        <Box>
          <Footer />
          <PoweredBy
            padding="16px 0 21px 0"
            clr = {"#000"} 
          />
        </Box>
      </Box>
    </>
  );
};
